import { Box, Flex, Heading, FormControl, FormLabel, Input, Button } from '@chakra-ui/react';
import { useState } from 'react';
import OtpInput from 'react-otp-input';

const PhoneLoginPage = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);

  const handlePhoneSubmit = () => {
    // Here you would typically send the OTP to the phone number via an API
    // For demonstration, we'll just log it
    console.log('Sending OTP to: ', phoneNumber);

    // Simulating OTP sent, set isOtpSent to true
    setIsOtpSent(true);
  };

  const handleOtpSubmit = () => {
    // Here you would typically verify the OTP with the backend
    console.log('Verifying OTP: ', otp);

    // After OTP verification, you can proceed with login logic
    // For demonstration, we'll just alert
    alert('OTP Verified! Proceed with login');
  };

  return (
    <Flex
      minH={'100vh'}
      align={'center'}
      justify={'center'}
      bgGradient="linear-gradient(to top, #0c3483 0%, #a2b6df 100%, #6b8cce 100%, #a2b6df 100%)"
      color="black"
    >
      <Box
        rounded={'lg'}
        bg={'white'}
        boxShadow={'lg'}
        p={8}
        maxW={'md'}
        w={'full'}
        color="black"
      >
        <Heading fontSize={'2xl'} color="black" textAlign={'center'} mb={5}>
          Phone OTP Login
        </Heading>
        {!isOtpSent ? (
          <>
            <FormControl>
              <FormLabel>Email</FormLabel>
              <Input
                type="tel"
                _placeholder={{ color: 'gray.400' }}
                border="2px solid"
                placeholder="Enter your phone number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                mb={3}
              />
              <FormLabel>Password</FormLabel>
              <Input
                type="tel"
                _placeholder={{ color: 'gray.400' }}
                border="2px solid"
                placeholder="Enter your  Password"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                mb={3}
              />
            </FormControl>
            <Button colorScheme="blue" size="md" w="full" onClick={handlePhoneSubmit}>
              Login
            </Button>
          </>
        ) : (
          <>
            <FormControl>
              <FormLabel>Enter Email</FormLabel>
              <OtpInput
                _placeholder={{ color: 'gray.400' }}
                border="2px solid"
                value={otp}
                onChange={(otp) => setOtp(otp)}
                numInputs={6}
                isInputNum
                separator={<span>-</span>}
                inputStyle={{
                  width: '3rem',
                  height: '3rem',
                  fontSize: '1.5rem',
                  margin: '0 0.5rem',
                  borderRadius: 'md',
                  border: '1px solid #CBD5E0',
                }}
                focusStyle={{
                  border: '2px solid #3182CE',
                }}
                containerStyle={{
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '1rem 0',
                }}
              />
            </FormControl>
            <Button colorScheme="blue" size="md" w="full" mt={4} onClick={handleOtpSubmit}>
              Verify OTP
            </Button>
          </>
        )}
      </Box>
    </Flex>
  );
};

export default PhoneLoginPage;
